<template>
    <client-page class="dark-theme">
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="교육 · 법률지원" src="/images/sub/sub-visual-education.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--last">
            <div v-if="application">
                <div class="mb-20px mb-md-30px mb-lg-40px" data-aos="fade-right" data-aos-delay="100">
                    <div class="font-size-20 font-size-md-30 font-size-lg-36 font-weight-bold">{{ application.subject }}</div>
                </div>

                <!-- S: 관리자 작성 항목-->
                <v-divider class="grey darken-4" style="border-width: 2px 0 0;" />
                <template v-for="(item, index) in application.items">
                    <v-row :key="index" no-gutters class="font-size-14 font-size-md-16 font-weight-regular font-pretendard">
                        <v-col cols="12" md="auto">
                            <v-layout align-center class="grey lighten-5 w-100 h-100 px-12px py-8px px-md-20px py-md-24px w-md-160px">
                                <span v-html="item.title.replace(/\n/g, '<br/>')" class="font-weight-medium grey--text text--darken-4"></span>
                            </v-layout>
                        </v-col>
                        <v-col cols="12" md="">
                            <v-layout align-center class="grey--text w-100 h-100 px-12px py-8px px-md-20px py-md-24px">
                                <span v-html="item.txt.replace(/\n/g, '<br/>')"></span>
                            </v-layout>
                        </v-col>
                    </v-row>
                    <v-divider :key="index" />
                </template>
                <!-- E: 관리자 작성 항목-->

                <!-- S: 버튼 -->
                <div class="mt-40px mt-md-50px text-center">
                    <v-row align="center" justify="center" class="row--xs">
                        <v-col cols="auto">
                            <v-btn x-large outlined color="secondary" href="#application-content" class="min-w-lg-180px justify-space-between">
                                상세보기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <!-- S: 문의처 -->
                            <v-dialog scrollable max-width="800" content-class="rounded-0">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" x-large outlined color="secondary" class="min-w-lg-180px justify-space-between">
                                        문의처
                                        <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                                    </v-btn>
                                </template>

                                <template v-slot:default="dialog">
                                    <v-card tile flat>
                                        <v-toolbar tile flat>
                                            <v-spacer></v-spacer>
                                            <v-toolbar-title class="font-size-18 font-weight-extrabold line-height-11 ml-24px d-md-none">문의처</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-btn x-large icon class="transparent" @click="dialog.value = false"><v-icon color="grey darken-4" size="24">mdi-close</v-icon></v-btn>
                                        </v-toolbar>
                                        <div class="px-30px pb-30px px-md-50px pt-md-10px pb-md-50px px-lg-60px pt-lg-12px pb-lg-80px">
                                            <div class="mb-30px mb-md-40px d-none d-md-block">
                                                <div class="font-size-md-24 font-weight-extrabold line-height-11 text-center">문의처</div>
                                            </div>

                                            <v-divider class="grey darken-4" style="border-width: 2px 0 0;" />
                                            <template v-for="(item, index) in application.helpItems">
                                                <v-row :key="index" no-gutters class="font-size-14 font-size-md-16 font-weight-regular font-pretendard">
                                                    <v-col cols="12" md="auto">
                                                        <v-layout align-center class="grey lighten-5 w-100 h-100 px-12px py-8px px-md-20px py-md-24px w-md-160px">
                                                            <span v-html="item.title.replace(/\n/g, '<br/>')" class="font-weight-medium grey--text text--darken-4"></span>
                                                        </v-layout>
                                                    </v-col>
                                                    <v-col cols="12" md="">
                                                        <v-layout align-center class="grey--text w-100 h-100 px-12px py-8px px-md-20px py-md-24px">
                                                            <span v-html="item.txt.replace(/\n/g, '<br/>')"></span>
                                                        </v-layout>
                                                    </v-col>
                                                </v-row>
                                                <v-divider :key="index" />
                                            </template>
                                        </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                            <!-- E: 문의처 -->
                        </v-col>
                        <v-col cols="auto">
                            <v-btn x-large tile outlined color="secondary" :href="application.link" target="_blank" class="min-w-lg-180px justify-space-between">
                                접수 바로가기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn x-large icon tile outlined color="grey" @click="copyClipboard">
                                <v-img :aspect-ratio="18 / 18" max-width="18" src="/images/icon/icon-link.svg" />
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 버튼 -->

                <!-- S: SNS버튼 -->
                <!-- <div class="mt-20px mt-md-30px">
                    <v-row align="center" justify="center" class="row--sm">
                        <v-col cols="auto">
                            <v-btn icon @click="shareFacebook"><v-img src="/images/icon/icon-facebook.png" alt="페이스북"/></v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn icon @click="shareKakao"><v-img src="/images/icon/icon-kakao.png" alt="카카오톡"/></v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn icon @click="shareInstagram"><v-img src="/images/icon/icon-insta.png" alt="인스타"/></v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn icon @click="copyClipboard"><v-img src="/images/icon/icon-link.png" alt="링크복사"/></v-btn>
                        </v-col>
                    </v-row>
                </div> -->
                <!-- E: SNS버튼 -->

                <!-- S: html 작성 -->
                <div class="pt-60px pt-xl-100px" id="application-content">
                    <v-divider class="grey darken-4 mb-20px mb-md-32px" style="border-width: 2px 0 0;" />
                    <div>
                        <div v-html="application.content" />
                    </div>
                </div>
                <!-- E: html 작성 -->
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";
import download from "downloadjs";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";
import IconDown from "@/components/client/icons/icon-down.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        IconArrowRounded,
        IconDown,
    },
    data() {
        return {
            application: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        download: (url, name) => api.resource.get(url).then((file) => download(file, name)),

        async init() {
            let { application } = await api.v1.education.applications.get({ _id: this.$route.params._id });
            this.application = application;
        },
        shareKakao() {
            try {
                let key = ""; // 웹 API 키
                if (!key) throw new Error("카카오에서 JAVASCRIPT API 키를 발급받아 전달해주세요.(+ 카카오에 WEB 정보를 등록해주세요)");

                let shareUrl = location.href;

                if (!Kakao.isInitialized()) Kakao.init(key);
                Kakao.Share.sendDefault({
                    objectType: "feed",
                    content: {
                        title: this.application.subject,
                        // description: '#케익 #딸기 #삼평동 #카페 #분위기 #소개팅',
                        imageUrl: `https://${location.host}/${this.application.thumb.src}`,
                        link: {
                            // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
                            // mobileWebUrl: 'https://developers.kakao.com',
                            mobileWebUrl: shareUrl,
                            // webUrl: 'https://developers.kakao.com',
                            webUrl: shareUrl,
                        },
                    },
                });
            } catch (error) {
                alert(error.message);
            }
        },
        shareFacebook() {
            try {
                let shareUrl = location.href;

                location.href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
            } catch (error) {
                alert(error.message);
            }
        },
        shareInstagram() {
            try {
                let client_id = ""; // 클라이언트 아이디
                if (!client_id) throw new Error("인스타그램 클라이언트 아이디를 발급받아 전달해주세요.");

                let shareUrl = location.href;

                location.href = `https://api.instagram.com/oauth/authorize/?client_id=${client_id}&redirect_uri=${shareUrl}&response_type=code`;
            } catch (error) {
                alert(error.message);
            }
        },
        copyClipboard() {
            try {
                if (!window?.navigator?.clipboard?.writeText) throw new Error("SSL 환경에서만 클립보드 복사 가능합니다");

                let shareUrl = location.href;

                window.navigator.clipboard.writeText(shareUrl);

                alert("복사 되었습니다");
            } catch (error) {
                alert(error.message);
            }
        },
    },
};
</script>
